import UserProfile from "../Context/UserProfile";
import { useEffect,useState } from "react";
const ContactUs = ({setUserName,setPageTitle}) => {
	const [displayName, setDisplayName] = useState();
	useEffect(() => {
		setUserName(UserProfile.getName());
        setDisplayName(UserProfile.getName());
        if(UserProfile.getLoginStatus()==="1"){
			setPageTitle("Contact Us");
		}
	}, [])
	return (
		<>
		<div className={displayName && displayName.length>0?"main-content":""}>
			{UserProfile.getLoginStatus()!=="1" && <><header>
				<div className="header-container">
					<div className="logo">
						<a style={{ textDecoration: "none" }} href="/">
							<span style={{ color: 'white' }}>Contr
								<span style={{ color: "#ff8400" }}>e</span>
								ct</span>
						</a>

					</div>
					<nav><a href="/Signup" className="btn btn-success">Sign In</a>
					</nav>
				</div>
			</header>
			<div style={{ paddingTop: '20px', paddingLeft: '20px' }}>
				<h1>Contact us</h1>
				<span className="effective-date">Last Updated: 3 December 2025</span>
			</div></>}
						<div style={{ marginTop: "5px", textAlign: "left", padding: "40px", maxHeight: "100%", overflowX: "scroll" }}>
				<div className="contact-info">
                        <p>If you have any questions about our use of cookies or this Cookie Policy, please contact us:</p>
                        <p>
                            <strong>Musedaq Fintech Private Limited</strong>
                            <br />
                            748/1 Shastri Ward, Babariya
                            <br />
                            Seoni (MP) - 480661, India<br />
                            <span style={{ fontSize: "1.1rem;" }} >📧</span> Email: <a href="mailto:arpandeepesh@gmail.com">arpandeepesh@gmail.com</a><br />
                            <span style={{ fontSize: "1.1rem;" }}>📞</span> Phone: <a href="tel:+918989430555">+91 8989430555</a>
                        </p>
                    </div>
			</div>
		</div>

		</>
	);
};
export default ContactUs;